// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const InfrastructureObservabilitySignetIconComponent =
  /* @__PURE__ */ forwardRef<SVGSVGElement, SvgIconProps>(
    (props: SvgIconProps, forwardedRef): JSX.Element => {
      return (
        <SvgIcon
          data-iconname="InfrastructureObservabilitySignetIcon"
          ref={forwardedRef}
          {...props}
        >
          <path d="M18.919 10.825a3.135 3.135 0 0 1-3.135 3.135H9.299a.164.164 0 0 1-.165-.165V6.73a.16.16 0 0 1 .07-.135 3.1 3.1 0 0 1 1.745-.554h.035a3.12 3.12 0 0 1 2.591 1.372l.004-.002a3.2 3.2 0 0 1 .425.836 3.134 3.134 0 0 1 4.915 2.58" />
          <path d="M8.142 6.725H7.044a.17.17 0 0 0-.17.17v1.098a.17.17 0 0 0 .17.17h1.098a.17.17 0 0 0 .17-.17V6.895a.17.17 0 0 0-.17-.17" />
          <path d="M8.138 10.587h-3.02a.174.174 0 0 0-.175.174v3.021a.174.174 0 0 0 .174.174h3.021a.174.174 0 0 0 .174-.174v-3.021a.174.174 0 0 0-.174-.174" />
          <path d="M8.142 8.656H7.044a.17.17 0 0 0-.17.17v1.098a.17.17 0 0 0 .17.17h1.098a.17.17 0 0 0 .17-.17V8.826a.17.17 0 0 0-.17-.17" />
          <path d="M6.211 8.656H5.113a.17.17 0 0 0-.17.17v1.098a.17.17 0 0 0 .17.17H6.21a.17.17 0 0 0 .17-.17V8.826a.17.17 0 0 0-.17-.17" />
          <path d="M4.28 12.519H3.182a.17.17 0 0 0-.17.17v1.098a.17.17 0 0 0 .17.17H4.28a.17.17 0 0 0 .17-.17v-1.099a.17.17 0 0 0-.17-.17" />
          <path d="M2.349 11.553H1.25a.17.17 0 0 0-.17.17v1.098a.17.17 0 0 0 .17.17h1.098a.17.17 0 0 0 .17-.17v-1.098a.17.17 0 0 0-.17-.17" />
          <path d="M4.28 10.587H3.182a.17.17 0 0 0-.17.17v1.098a.17.17 0 0 0 .17.17H4.28a.17.17 0 0 0 .17-.17v-1.098a.17.17 0 0 0-.17-.17" />
          <path d="M3.315 7.69H2.216a.17.17 0 0 0-.17.17v1.1a.17.17 0 0 0 .17.17h1.099a.17.17 0 0 0 .17-.17v-1.1a.17.17 0 0 0-.17-.17" />
        </SvgIcon>
      );
    },
  );

/**
 * @public
 */
export const InfrastructureObservabilitySignetIcon =
  /* @__PURE__ */ Object.assign(
    InfrastructureObservabilitySignetIconComponent,
    { displayName: 'InfrastructureObservabilitySignetIcon' },
  );
